// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home .top-fixed {\n  top: 0;\n  right: 0;\n  width: 100%;\n  position: fixed;\n  z-index: 99;\n}\n.home > .content {\n  top: 9rem;\n  position: relative;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
